import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ChipsViewModel from '@/ViewModels/Controls/ChipsViewModel';
import Chips from '@/Controls/Chips';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';

export default class ChipsFactory extends ControlFactory {

    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private ChipsViewModel = ComponentManager.getViewModel<typeof ChipsViewModel>('ChipsViewModel');
    private Chips = ComponentManager.getControl<typeof Chips>('Chips')

    /**
     * @override
     */
    public viewModel: ChipsViewModel<any>;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: Chips;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.ChipsViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            isFocusable: this.isFocusable,
            values: this.context.genericObject.getObservable(this.detailViewItem.name),
            dotNetTypeName: this.detailViewItem.dotNetTypeName
        });

        this.control = new this.Chips(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: this.viewModel?.value() || ''
        }
    }

}

ComponentManager.setFactory('Chips', ChipsFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');